
import { SMUser } from "@/store";
import { computed, defineComponent } from "vue-demi";

interface IFolder {
  ID: number;
  name: string;
  displayName: string;
  type: "folder";
  full_route: string;
  is_approved: boolean;
  is_filled: boolean;
}

export default defineComponent({
  name: "FolderView",

  components: {
    FolderStatus: () => import("@/modules/Documents/FolderStatus.vue"),
  },

  props: {
    folder: { type: Object as () => IFolder, required: true },
    folderStatus: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["open-folder"],

  setup(props, { emit }) {
    const onOpenFolder = (fullRoute: string) => {
      emit("open-folder", fullRoute);
    };

    const isExpert = computed(() => SMUser.isExpert);

    const isAdditionalDocuments = computed(
      () => props.folder.displayName === "Additional documents"
    );

    return {
      isExpert,
      onOpenFolder,
      isAdditionalDocuments,
    };
  },
});
